module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/polkolonie/big/7-cecf397a65fd8dc8f29800d3ff1b0f7d.webp";